<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-info"></i> Detalle de Orden de Devolución {{order.code}}
      <div class="card-header-actions btn-group" dropdown placement="bottom left">
        <button type="button" (click)="print()" class="btn btn-sm btn-outline-success"><i
            class="fa fa-regular fa-file"></i>&nbsp;Imprimir Documentos</button>

      </div>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          <button type="button" (appPrivilegeClick)="return()" [disabled]="validateReturned()" appPrivilege="doReturn"
            class="btn btn-sm btn-outline-success float-right"><i class="fa fa-arrow-left"></i>&nbsp;Devolver</button>
          <button type="button" (appPrivilegeClick)="voidOperation()" [disabled]="validateVoided()"
            appPrivilege="doReturn" class="btn btn-sm btn-outline-success float-right"><i
              class="fa fa-ban"></i>&nbsp;Anular</button>
        </div>
      </div>

      <accordion [isAnimated]="true">
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-users'></i> Información General
          </span>
          <div class="form-group row">
            <label class="col-md-3 col-form-label"><b>Cliente</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" disabled
                [(ngModel)]="customerInformation">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Vendedor</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="sellerInformation"
                disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Documento Fiscal</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control"
                [(ngModel)]="order.customerFiscalId" disabled>
            </div>
          </div>
          <div class="form-group row" [hidden]="order.invoiceNumber == ''">
            <label class="col-md-3 col-form-label" for="text-input"><b>Factura Original</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control"
                [(ngModel)]="order.invoiceNumber" disabled>
            </div>
          </div>
          <div class="form-group row" [hidden]="!order.receiptCode">
            <label class="col-md-3 col-form-label" for="text-input"><b>Recibo Original</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="order.receiptCode"
                disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Fecha de Orden de Devolución</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="order.timeStamp"
                disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Motivo de Devolución</b></label>
            <div class="col-md-9 text-left">
              <span [ngClass]="'badge large-font-size badge-warning'">{{order.cancellationReason}}</span>
            </div>

          </div>
        </accordion-group>
        <accordion-group [isOpen]="true" *ngIf="order.condition == 'credito'">
          <span accordion-heading>
            <i class='fa fa-regular fa-file-lines'></i> Contratos a Devolver
          </span>
          <pos-table tableFormId="loanTable" [data]="loans" [headers]="getLoanHeaders()" [itemsPerPage]="10"
            [pagination]="false" [disableHighlight]="true">
          </pos-table>
        </accordion-group>
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-regular fa-file-lines'></i> Notas de crédito
          </span>
          <pos-table tableFormId="invoiceTable" [data]="invoices" [headers]="getInvoiceHeaders()" [itemsPerPage]="10"
            [pagination]="false" [disableHighlight]="true" [badgeSecondaryValues]="['CANCEL']"
            [badgeWarningValues]="['VOID']">
          </pos-table>
        </accordion-group>
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-file-text'></i> Transacciones:
          </span>
          <pos-table tableFormId="transactionsTable" [disableHighlight]="true" [data]="transactions"
            [headers]="getTransactionsHeaders()" [filters]="[]" [itemsPerPage]="10" [pagination]="false"
            [badgeSuccessValues]="['FINISHED']" [badgeWarningValues]="['NEW']" [badgeDangerValues]="['LOANS',
          'DOWNPAYMENT_RECEIPT',
          'DOCUMENT_ATTACHMENTS','INVOICES',
                                    'NOTE_CHARGE',
                                    'NOTE_CHARGE_PAYMENT',
                                    'PAYMENTS',
                                    'NO_STATUS']">
          </pos-table>
        </accordion-group>
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-cart-shopping'></i> Orden
          </span>
          <pos-totals [totals]="order.totals"></pos-totals>
          <div class="row">
            <div class="col-12">
              <pos-table tableFormId="productsCartTable" [data]="productsCart" [headers]="getProductCartHeaders()"
                [filters]="[]" [itemsPerPage]="10" [pagination]="false" [disableHighlight]="true">
              </pos-table>
            </div>
          </div>
        </accordion-group>
      </accordion>
    </div>

  </div>
</div>